import { MD3DarkTheme, MD3LightTheme, useTheme } from 'react-native-paper';

export const darkTheme = {
  ...MD3DarkTheme,
  colors: {
    ...MD3DarkTheme.colors,
    primary: '#DE6750',
    onPrimary: 'white',
    error: '#BD3F09',
    background: '#00101B',
    backgroundBorder: 'rgba(255, 255, 255, 0.23)',
    handleColor: '#002E4B',
    snackbarError: 'red',
    openMarkerColor: '#2DBD09',
    closedMarkerColor: '#808080',
    activeMarkerColor: '#9909BD',
  },
};

export const lightTheme = {
  ...MD3LightTheme,
  colors: {
    ...MD3LightTheme.colors,
    primary: '#004370',
    onPrimary: 'white',
    background: 'white',
    backgroundBorder: 'rgba(0, 0, 0, 0.23)',
    handleColor: '#E6E6E6',
    error: 'orange',
    snackbarError: 'red',
    openMarkerColor: '#2DBD09',
    closedMarkerColor: '#808080',
    activeMarkerColor: '#9909BD',
  },
};

export type AppTheme = typeof darkTheme;

export const useAppTheme = () => useTheme<AppTheme>();
